import { IconEditBig } from 'central-icons/IconEditBig';
import mixpanel from 'mixpanel-browser';
import type { FC } from 'react';

import { BuildADashTrackingEvents } from '@revelio/core';

import { ActionBarIconButton } from './ActionBarIconButton';

interface ViewModeButtonsProps {
  isOwner: boolean;
  onSetEditMode: () => void;
  pageId: string;
}

export const ViewModeButtons: FC<ViewModeButtonsProps> = ({
  isOwner,
  onSetEditMode,
  pageId,
}) => {
  return (
    <ActionBarIconButton
      icon={IconEditBig}
      iconSize={16}
      aria-label="Edit Page"
      tooltipLabel={isOwner ? 'Edit Page' : 'Copy and Edit Page'}
      onClick={() => {
        onSetEditMode();
        if (isOwner) {
          mixpanel.track(BuildADashTrackingEvents.EDIT_PAGE, {
            page_id: pageId,
          });
        } else {
          mixpanel.track(BuildADashTrackingEvents.CLONE_PAGE, {
            page_id: pageId,
          });
        }
      }}
    />
  );
};
